<template>
  <div>
      <div class="row mt-4">

      <div class="col-md-12 col-12 form-field">

        <div class="col-md-12 mb-2 px-0 mb-4">
        <span class="back-btn" @click="navigateToPreviousPage">
          <font-awesome-icon icon="arrow-left" size="sm"/>
          Back
        </span>
        </div>
        <div v-if="validateIfBankTransferOnly" class="col-md-12 col-12 px-0">
          <div class="pb-3">
            <div class="title mt-2 mb-3">
              <div>Bank transfer only</div>
              <div class="font-italic">Please contact <a :href="CONSTANTS.ACCOUNTS_PAYABLE_SLACK" target="_blank">
                <strong>Accounts Payable via Lumi</strong></a> if the payment made is other than bank transfer.</div>
            </div>
          </div>
        </div>
        <div v-else class="col-md-12 col-12 form-field px-0">
          <div class="mb-2">
            <div class="title required-field mt-2 mb-3">
              <span>{{FORM_LABELS.TYPE_OF_PAYMENT_LABEL}}</span>
            </div>
            <div class="row">
              <div v-for="(paymentType, index) in filteredPaymentOptions" :key="index" class="col-md-6 col-12 mt-1">
                <label class="label-font">
                  <input
                    type="radio"
                    name="paymentType"
                    class="mr-1"
                    v-model="currentFormData.paymentType"
                    :value="paymentType.value"
                    @click="resetPaymentData"
                    v-validate="'required'">{{paymentType.text}}
                </label>
              </div>
            </div>
            <show-errors :for-item="'paymentType'" :form-errors="errors" :field-name="FORM_LABELS.TYPE_OF_PAYMENT_ERROR_LABEL" />

          </div>
        </div>

        <div v-if="isAccountNameRequired">
          <div v-if="isFormEligibleForBankDropDown">
            <!--This div has been mandatory kept empty because after checking  "isFormEligibleForBankDropDown", i.e:- PO, NONPO, ADVPO ,
            we need to change the order hence hiding the field from here and placing it inside BankTransfer.vue for ordering it below Bank Account Holder name -->
            <!--An additional check is also there below to see if the paymentType === cheque , its because we need cheque to have Bank Account Holder name field but since the even if its PO and NON PO-->
            <div v-if="this.currentFormData.paymentType === 'cheque'">
              <div class="title pt-2" :class="isAccountNameRequired ? 'required-field':''">
                <span>{{FORM_LABELS.ACCOUNT_HOLDER_NAME}}</span>
              </div>
              <div class="mb-4 my-2">
                <input
                    class="form-control"
                    name="currentFormData.bankAccountHolderName"
                    v-model="currentFormData.bankAccountHolderName"
                    id="currentFormData.bankAccountHolderName"
                    v-validate="{required: isAccountNameRequired, max: 60}"
                    data-vv-validate-on="input"
                    autocomplete="off"
                    data-lpignore="true"
                >
                <show-errors :for-item="'currentFormData.bankAccountHolderName'" :form-errors="errors" :field-name="FORM_LABELS.ACCOUNT_HOLDER_NAME" :max-length="60" />
              </div>
            </div>
          </div>
          <div v-else>
            <!--This div gets triggered when the formType is OTV or AdvPO-->
              <div class="title pt-2" :class="isAccountNameRequired ? 'required-field':''">
                <span>{{FORM_LABELS.ACCOUNT_HOLDER_NAME}}</span>
              </div>
              <div class="mb-4 my-2">
                <input
                    class="form-control"
                    name="currentFormData.bankAccountHolderName"
                    v-model="currentFormData.bankAccountHolderName"
                    id="currentFormData.bankAccountHolderName"
                    v-validate="{required: isAccountNameRequired, max: 60}"
                    data-vv-validate-on="input"
                    autocomplete="off"
                    data-lpignore="true"
                >
                <show-errors :for-item="'currentFormData.bankAccountHolderName'" :form-errors="errors" :field-name="FORM_LABELS.ACCOUNT_HOLDER_NAME" :max-length="60" />
              </div>
          </div>
        </div>


        <div v-if="currentFormData.paymentType === CONSTANTS.MODE_OF_PAYMENT.BANK_TRANSFER || validateIfBankTransferOnly">
          <bank-transfer-form :formData="formData" />
        </div>
        <div v-else-if="currentFormData.paymentType === CONSTANTS.MODE_OF_PAYMENT.DIRECT_DEBIT">
          <direct-debit-form :formData="formData" />
        </div>
        <div v-else-if="currentFormData.paymentType === CONSTANTS.MODE_OF_PAYMENT.CITI_DIRECT_PAYMENT">
          <citi-direct-payroll-payment-form :formData="formData" />
        </div>
        <div v-else-if="currentFormData.paymentType === CONSTANTS.MODE_OF_PAYMENT.BOLETO">
          <boleto-payment-form :formData="formData" />
        </div>




        <div class="float-md-right mt-4 pr-0">
          <button class="btn-container flat-btn gray-btn close-btn btn mx-2 my-3" @click="navigateToHome">Cancel</button>
          <button v-if="isFormEligibleForDraftRequest" class="btn submit-btn btn-outline-info outline-flat-btn" @click="saveDraftData()">Save Draft</button>
          <button class="btn-container btn flat-btn primary-blue-btn ml-2 my-3" :disabled="validateToDisablePreviewButton" @click="validateAndNavigateToPreviewPage()">Preview</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaymentFormsMixin from "@/mixins/PaymentFormsMixin";
import BankTransferForm from "@/components/Payments/PaymentDetailsForm/BankTransferForm";
import DirectDebitForm from "@/components/Payments/PaymentDetailsForm/DirectDebitForm";
import CitiDirectPayrollPaymentForm from "@/components/Payments/PaymentDetailsForm/CitiDirectPayrollPaymentForm";
import BoletoPaymentForm from "@/components/Payments/PaymentDetailsForm/BoletoPaymentForm";
import {mapGetters, mapMutations} from "vuex"
import CONSTANTS from "@/store/constants";

export default {
  name: "PaymentDetailsForm",
  components: {BankTransferForm, DirectDebitForm, CitiDirectPayrollPaymentForm, BoletoPaymentForm},
  mixins: [PaymentFormsMixin],
  props: {
    formData: String,
    backNav: String,
    nextNav: String
  },
  created() {
    // true if the form only accepts bank transfer as paymentType
    if(this.validateIfBankTransferOnly) {
      this.currentFormData.paymentType = CONSTANTS.MODE_OF_PAYMENT.BANK_TRANSFER
    }
  },
  computed: {
    ...mapGetters(["isBankDetailsCheckedAsHidden"]),
    validateIfBankTransferOnly(){
         return this.isFormOneTimeSupplierPayment || this.isFormDraftOneTimeSupplierPayment || this.isFormAdvancePOBasedPayment
    },
    currentFormData() {
      return this.$store.getters[this.formData]
    },
    isAccountNameRequired() {
      return this.currentFormData.paymentType ?
          this.adminDataList.paymentTypeOptions.find(item => item.value === this.currentFormData.paymentType).isAccountHolderNameMandatory : false
    },
    isBoletoPaymentRequired() {
      return this.currentFormData && this.currentFormData.companyCode === CONSTANTS.BOLETO_COMPANY_CODE
    },
    filteredPaymentOptions() {
      let paymentOptions = this.adminDataList.paymentTypeOptions
      if(!this.isBoletoPaymentRequired) {
        paymentOptions = paymentOptions.filter(options => options.text !== "Boleto")
      }
      return paymentOptions
    },
    isFormNonPo() {
      return this.$route.name.includes(CONSTANTS.NON_PO_PAYMENT_FORM)
    },
    isFormOneTimeSupplierPayment(){
      return this.$route.name.includes(CONSTANTS.ONE_TIME_SUPPLIER_PAYMENT)
    },
    isFormDraftOneTimeSupplierPayment(){
      return this.$route.name.includes(CONSTANTS.DRAFT_ONE_TIME_SUPPLIER_PAYMENT_FORM)
    },
    isFormAdvancePOBasedPayment(){
      return this.$route.name.includes(CONSTANTS.ADV_PO_BASED_PAYMENT_FORM)
    },
    validateToDisablePreviewButton(){
      return !this.isBankDetailsCheckedAsHidden &&
          this.currentFormData.paymentType === CONSTANTS.MODE_OF_PAYMENT.BANK_TRANSFER &&
          (this.$route.meta.tab === CONSTANTS.PO_BASED_PAYMENT_FORM ||
              this.$route.meta.tab === CONSTANTS.DRAFT_PO_BASED_PAYMENT_FORM ||
              this.$route.meta.tab === CONSTANTS.NON_PO_PAYMENT_FORM ||
              this.$route.meta.tab === CONSTANTS.DRAFT_NON_PO_BASED_PAYMENT_FORM ||
              this.$route.meta.tab === CONSTANTS.ADV_PO_BASED_PAYMENT_FORM)
    }
  },
  methods: {
    ...mapMutations(["setIsFormDataLoaded","resetFormPaymentData"]),
    resetPaymentData() {

      // This method only resets payment related items for corresponding form objects.
      // We cannot reset all values as user has values from previous page which should not be reset.

      let form = this.currentFormName
      this.resetFormPaymentData(form)

    },
    validateAndNavigateToPreviewPage(){
      //This check is to ensure that if paymentType is not cheque or bankTransfer, we delete bankAccountHolderName
      if ((!(this.currentFormData.paymentType === 'cheque'))  && (!(this.currentFormData.paymentType === 'bankTransfer'))){
        delete this.currentFormData.bankAccountHolderName
      }
      this.validateAndSetCurrentTab(this.nextNav)
    },
    navigateToPreviousPage() {
      this.setIsFormDataLoaded(true)
      this.$emit('setCurrentTab',this.backNav)
    },
    saveDraftData(){
      return this.isFormNonPo ? this.saveDraftNonPOBasedPaymentRequest(true) : (this.isFormOneTimeSupplierPayment ? this.saveDraftOneTimeSupplierPaymentRequest(true) : this.saveDraftPOBasedPaymentRequest(true))
    }
  },

}

</script>

<style scoped>
.preview-notification {
  margin-left: 0
}

.select-style >>> .ui.selection.dropdown .menu  {
  max-height: 150px;
}


.checkboxes-field label {
  display: block;
  padding-right: 10px;
  padding-left: 22px;
  text-indent: -22px;
}
.checkboxes-field input {
  vertical-align: middle;
}
.checkboxes-field label span {
  vertical-align: middle;
}

.currency-select {
  max-width: 70px;
}

.tax-team-container {
  width: 100%;
  text-align: left;
  border-bottom: 1px solid #000;
  line-height: 0.1em;
  margin: 40px 0 20px;
}

.tax-team-container span {
  background:#fff;
  padding:0 10px 0 0;
}

</style>